module.exports = __webpack_public_path__ + "static/img/electronic.cb29c61.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/electronic.png
// module id = a4vM
// module chunks = 2